/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { ICheckoutState } from '@msdyn365-commerce/global-state';
import {
    AsyncResult, CardPaymentAcceptPoint
} from '@msdyn365-commerce/retail-proxy';

export enum ApplePayButtonState {
    Unknown,
    NotAvailable,
    Available
};

/**
 * Interface for checkout apple pay data.
 */
export interface ICheckoutApplePayData {
    checkout?: AsyncResult<ICheckoutState>;
    cardPaymentAcceptPoint?: AsyncResult<CardPaymentAcceptPoint>;
}